import React, {type FC} from 'react'
import ShikiHighlighter from 'react-shiki/web'
import type {OmicsSyntaxHighlighterProps as AuiSyntaxHighlighterProps} from './omicsMarkdownTypes'
import {mapShikiLanguage} from './omicsShikiLanguage'

export {mapShikiLanguage} from './omicsShikiLanguage'

/** assistant-ui `SyntaxHighlighter` slot — Shiki via react-shiki/web. */
export const OmicsShikiHighlighter: FC<AuiSyntaxHighlighterProps> = ({
  code,
  language,
  components: {Pre},
}) => {
  const shikiLang = mapShikiLanguage(language)

  return (
    <Pre className='omics-aui-code-pre omics-aui-shiki-pre'>
      <ShikiHighlighter
        language={shikiLang}
        theme={{light: 'github-light', dark: 'github-dark'}}
        defaultColor='light-dark()'
        addDefaultStyles={false}
        showLanguage={false}
        className='omics-aui-shiki aui-shiki-base'
      >
        {code.trimEnd()}
      </ShikiHighlighter>
    </Pre>
  )
}

OmicsShikiHighlighter.displayName = 'OmicsShikiHighlighter'
